import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import type { PhoneCandidate } from '../modules/Auth/types/phoneAuth'

export interface DobResult {
  patientId: string
  emailHint: string | null
  hasAddress: boolean | null
  acceptsHipaa: boolean | null
  smsNotifications: boolean | null
}

export interface PhoneRegistration {
  token: string
  expiresAt: string | null
  outcome: 'found' | 'choose' | 'new'
  candidates: PhoneCandidate[]
  selectedPatientId?: string | null
  // The check-dob answer, valid only for the record it was given for
  dobResult?: DobResult | null
  // The collected form answers, kept across the redirect to Google and back
  draft?: unknown
  phone: string | null
  email: string | null
  emailVerified: boolean
}

interface PhoneRegistrationState {
  registration: PhoneRegistration | null
  setRegistration: (registration: PhoneRegistration) => void
  patchRegistration: (patch: Partial<PhoneRegistration>) => void
  clearRegistration: () => void
}

export const usePhoneRegistrationStore = create<PhoneRegistrationState>()(
  devtools(
    persist(
      (set) => ({
        registration: null,
        setRegistration: (registration) => set({ registration }, false, 'setRegistration'),
        patchRegistration: (patch) =>
          set(
            (state) => ({ registration: state.registration ? { ...state.registration, ...patch } : null }),
            false,
            'patchRegistration',
          ),
        clearRegistration: () => set({ registration: null }, false, 'clearRegistration'),
      }),
      {
        name: 'phone-registration-storage',
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
    { name: 'PhoneRegistrationStore' },
  ),
)
